/** 地区数据API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/districtData';
/**
 * 分页查询地区数据
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Common.DistrictData> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询地区数据列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Common.DistrictData> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个地区数据
 *
 * @param id 地区数据ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Common.DistrictData> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存地区数据
 *
 * @param params 地区数据信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新地区数据信息
 *
 * @param params 地区数据信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除地区数据
 *
 * @param id 地区数据ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除地区数据
 *
 * @param ids 地区数据ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
